import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import VehicleCategoryTable from "components/vehicleCategory/VehicleCategoryTable";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";
import VehicleModelServices from "services/VehicleModelServices";
import { FiPlus } from "react-icons/fi";
import VehicleCategoryDrawer from "components/drawer/VehicleCategoryDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import Somethingwentwrong from "pages/Somethingwentwrong";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import sidebar from "routes/sidebar";
import DataWrapper from "./DataWrapper";
import { FiRefreshCcw } from "react-icons/fi";

const VehicleCategory = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [status, setStatus] = useState("");
  const { data, loading, error } = useAsync(
    VehicleModelServices.getAllVehicleModel
  );
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle category" && perm.view === 1
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle category" && perm.delete === 1
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle category" && perm.edit === 1
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle category" && perm.add === 1
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle category" && perm.export === 1
      );

  const {
    vehicleModelRef,
    dataTable,
    serviceData,
    handleSubmitVehicleModel,
    currentPage,
  } = useFilter(Array.isArray(data.data) ? data.data : [], itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const updatedData = data?.data?.map((item, index) => {
    // console.log(item);
    return {
      "SI.No": index + 1,
      "Vehicle Name": item.name,
      Category: item.vehcilecategory,
    };
  });

  const handleRefresh = () => {
    setIsUpdate(true);
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <VehicleCategoryDrawer id={serviceId} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={vehicleModelRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitVehicleModel}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Vehicle Model
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    exportDataXlsx={updatedData}
                    fileNames="Vehicle Model"
                  />
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize text-center sticky top-0 z-10">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Vehicle Category</TableCell>
                        <TableCell>Vehicle Model</TableCell>
                        <TableCell>Actions</TableCell>
                      </tr>
                    </TableHeader>
                    <VehicleCategoryTable
                      vehicleCategory={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideEdit={hideEdit}
                      hideDelete={hideDelete}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Vehicle Category." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default VehicleCategory;
